<template>
    <div class="filter-tags" >
        <div class="filter-tags-middle" v-on:mouseleave="handleLeave" v-on:mouseover="handleEnter">
            <div class="filter-tags-inner" >
                <div class="filter-tag" v-for="filter in allAppliedFilters" :key="`${filter.text}${filter.value}`">
                    {{ filter.text }}
                </div>
            </div>
            <div class="shadow-box"></div>
            <Tooltip v-if="show">
                <h4>Applied Filters</h4>
                <div class="divider"></div>
                <p v-html="allAppliedFilters.map(filter => `<span>${filter.text}</span>`).join(', ')"></p>
            </Tooltip>
        </div>
        <div class="filter-tags-middle filter-tags-middle-actions" >
            <div class="filter-tags-inner">
                <button type="button" class="btn btn-secondary btn--small v-btn filter-chart" v-on:click="toggleFilters">
                    <img src="../../../assets/images/filters-white.svg" alt="Filters">
                    <span>FILTERS</span>
                </button>
            </div>
        </div>
    </div>
</template>

<script>

import Tooltip from '../../common/Tooltip.vue';

export default {
    components: {
        Tooltip,
    },
    data(){
        return {
            show: false
        }
    },
    props: {
        chart: {
            type: Object,
        },
        chartTypes: {
            type: Array,
        },
        cumulativeTypes: {
            type: Array,
        },
        growthRates: {
            type: Array,
        },
        growthRatesQuarters: {
            type: Array,
        },
        companies: {
            type: Array,
        },
        categories: {
            type: Array,
        },
        subcategories: {
            type: Array,
        },
        classes: {
            type: Array,
        },
        brands: {
            type: Array,
        },
        excludeBrands: {
            type: Array,
        },
        quarterData: {
            type: Array,
        },
        ranges: {
            type: Array,
        },
        revenueFilterRanges: {
            type: Array,
        },
        revenues: {
            type: Array,
        },
        tags: {
            type: Array,
        },
    },
    methods:{
        handleLeave(){
            this.show=false;
        },
        handleEnter(){
            this.show=true;
        },
        toggleFilters(){
            this.$store.commit('chart/toggleFilters');
        },
        chartRevenuesRangeFormat(chartFiltersRevenues) {
            if (chartFiltersRevenues == null) {
                return '- MIL';
            }
            const chartFiltersRevenuesSplit = chartFiltersRevenues.toString().split(',');
            if (chartFiltersRevenuesSplit == null || chartFiltersRevenuesSplit[0] === '') {
                return '- MIL';
            }
            if (chartFiltersRevenuesSplit[0] && !chartFiltersRevenuesSplit[1]) {
                return chartFiltersRevenuesSplit[0] + ',- MIL';
            }
            if ((!chartFiltersRevenuesSplit[0] || chartFiltersRevenuesSplit[0] === '0') && chartFiltersRevenuesSplit[1]) {
                return '-,' + chartFiltersRevenuesSplit[1] + ' MIL';
            }
            return chartFiltersRevenuesSplit + ' MIL';
        },
    },
    computed: {
        allAppliedFilters() {
            const chartType = this.chartTypes.find(type => type.value === this.chart.filters.chartType);
            const cumulativeType = (this.chart.filters.cumulativeType) ? {
                'text':  (this.chart.filters.cumulativeType === 'none') ? 'Cumulative: Brand' : 'Cumulative: ' + this.chart.filters.cumulativeType,
                'value': this.chart.filters.cumulativeType
            } : {'text': 'Cumulative: Brand', 'value': 'none'};
            const chartRange =(this.chart.filters.range)? {'text':'Launch: '+this.chart.filters.range, 'value':this.chart.filters.range} :{'text':'Launch Range: ALL', 'value':'ALL'};
            const chartRevenueFilterRange =(this.chart.filters.revenueFilterRange)? {'text':'Revenue: ' +this.chart.filters.revenueFilterRange, 'value':this.chart.filters.revenueFilterRange} :{'text':'Revenue: ALL', 'value':'Revenue: ALL'};
            let chartFilterRevenues = this.chartRevenuesRangeFormat(this.chart.filters.revenues);
            const chartRevenuesRange = {'text':'Dollars Range: ' + chartFilterRevenues, 'value':chartFilterRevenues};

            const growthRates = this.chart.filters.growthRates.map(
                growthRateValue => this.growthRates.find(growthRate => growthRate.value === growthRateValue),
            );

            const companies = this.chart.filters.companies.map(
                companyValue => this.companies.find(company => company.value === companyValue),
            );

            const categories = this.chart.filters.categories.map(
                categoryValue => this.categories.find(category => category.value === categoryValue),
            );

            const subcategories = this.chart.filters.subcategories.map(
                subcategoryValue => this.subcategories.find(subcategory => subcategory.value === subcategoryValue),
            );

            const classes = this.chart.filters.classes.map(
                classValue => this.classes.find(classObject => classObject.value === classValue),
            );

            const brands = this.chart.filters.brands.map(
                brandValue => this.brands.find(brand => brand.value === brandValue),
            );

            const excludeBrands = this.chart.filters.excludeBrands.map(
                excludeBrandValue => this.excludeBrands.find(excludeBrand => excludeBrand.value === excludeBrandValue),
            );

            const excludeBrandArray = [];

            excludeBrands.forEach((entry) => {
                excludeBrandArray.push(entry.text);
            });

            const excludeBrandString = {'text': 'Exclude Brands: ' + (excludeBrandArray.length > 0 ? excludeBrandArray.join(', ') : '-'), 'value': 'ALL'};

            const tags = this.chart.filters.tags.map(
                tagValue => this.tags.find(tag => tag.value === tagValue),
            );

            const chartCurves = (this.chart.filters.curves) ? { 'text' : 'Top Curves: ' + this.chart.filters.curves, 'value' : this.chart.filters.curves} :{ 'text' : 'Top Curves: -', 'value' : 'ALL'};

            const quarterData = (this.chart.filters.quarterData) ? { 'text' : 'Quarters: ' + this.chart.filters.quarterData, 'value' : this.chart.filters.quarterData } : { 'text' : 'Quarters: ALL', 'value' : 'ALL' };

            let result = [];

            if (this.chart.filters.chartType === 'growth' || this.chart.filters.breakApart) {
                let newChartType = this.chart.filters.breakApart ? this.chartTypes.find(type => type.value === this.chart.filters.parentChartType) : chartType;
                result = [newChartType, ...growthRates, ...companies, ...categories, ...subcategories, ...classes, excludeBrandString, ...brands, ...tags, chartCurves, quarterData];
            } else if (this.chart.filters.chartType === 'new') {
                result = [chartType, chartRange, chartRevenueFilterRange, chartRevenuesRange, ...companies, ...categories, ...subcategories, ...classes, excludeBrandString, ...brands, ...tags, chartCurves, quarterData];
            } else {
                result =  [chartType, cumulativeType, chartRevenueFilterRange, chartRevenuesRange, ...companies, ...categories, ...subcategories, ...classes, excludeBrandString, ...brands, ...tags, chartCurves, quarterData];
            }

            if (this.chart.filters.showCumulativeRevenueChart){
                result=[{ 'text' : 'Cumulative Revenue'}, ...result];
            }
            
            if (this.chart.filters.startSyncView){
                result=[{ 'text' : 'Sync View'}, ...result];
            }
            
           return result;
        },
    },
};

</script>

<style lang="scss">
    @import '../../../style/Charts/ViewChart/TagsComponent.scss';
</style>
